import { render, staticRenderFns } from "./ResourceChart.vue?vue&type=template&id=16c4e536&scoped=true&"
import script from "./ResourceChart.vue?vue&type=script&lang=ts&"
export * from "./ResourceChart.vue?vue&type=script&lang=ts&"
import style0 from "./ResourceChart.vue?vue&type=style&index=0&id=16c4e536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c4e536",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VIcon,VTooltip})
